<template lang="pug">
div
  | Posts
</template>
<script>
export default {
  name: 'Posts'
}
</script>



// WEBPACK FOOTER //
// src/features/admin/posts.vue